module.exports = __webpack_public_path__ + "static/media/eyelash-2.935f759f.png";